import { Label } from "@/components/ui/label";
import { Select, SelectContent, SelectItem, SelectTrigger, SelectValue } from "@/components/ui/select";

export function ClubSelectField({ formData, f, managedClubs }) {
  return (
    <div>
      <Label className="text-sm">Verein</Label>
      <Select value={formData.club_id || ""} onValueChange={v => f("club_id", v)}>
        <SelectTrigger className="mt-1 bg-input/50 border-white/10 rounded-none" data-testid="dialog-club-select">
          <SelectValue placeholder="Verein wählen" />
        </SelectTrigger>
        <SelectContent>
          {managedClubs.map(c => (
            <SelectItem key={c.id} value={c.id}>{c.name}</SelectItem>
          ))}
        </SelectContent>
      </Select>
    </div>
  );
}
